<template>
  <div class="fseg" :class="{ sm: small }">
    <button
      v-for="o in options"
      :key="o.value"
      type="button"
      :class="{ on: Number(value) === Number(o.value) }"
      @click="$emit('input', o.value)"
    >{{ o.text }}</button>
  </div>
</template>

<script>
import { FREQ_OPTIONS } from '../../v2/status'

export default {
  name: 'FreqSeg',
  props: {
    value: { type: [Number, String], default: 0 },
    small: { type: Boolean, default: false }
  },
  data() {
    return { options: FREQ_OPTIONS }
  }
}
</script>
